module.exports = __webpack_public_path__ + "static/img/difference_ttl.f614db9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/difference_ttl.svg
// module id = kVo4
// module chunks = 0